import React from 'react';

// Elenco compatto delle fonti dietro un numero del dataset open (migration
// 011): nome linkato se c'è url, separati da virgola. Niente wrapping in
// bullet/badge per restare su una riga in un blocco già stretto.
const SourceList = ({ sources }) => {
  if (!Array.isArray(sources) || sources.length === 0) return null;
  return sources.map((source, index) => (
    <span key={source.name || index}>
      {index > 0 && ', '}
      {source.url ? (
        <a
          href={source.url}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-gray-900"
        >
          {source.name}
        </a>
      ) : (
        source.name
      )}
    </span>
  ));
};

export default SourceList;
